import { AxiosPromise } from 'axios';
import { URLS } from '@/services/Constants';
import { commonAxios as axios } from '@/services/Authentication';

export default {
  // GET

  /**
   * Return conference default configuration
   *
   * @returns {AxiosPromise<any>}
   */
  getDefaultConfiguration(language: string = 'default'): AxiosPromise<any> {
    return axios().request({
      url: URLS().urlConference + '/defaults?locale=' + language,
      method: 'get'
    });
  },

  /**
   * Return conference configuration
   *
   * @returns {AxiosPromise<any>}
   */
  getConfiguration(): AxiosPromise<any> {
    return axios().request({
      url: URLS().urlConference,
      method: 'get'
    });
  },

  // PUT

  /**
   * Update configuration according to provided data
   *
   * @param {*} data
   * @returns {AxiosPromise<any>}
   */
  updateConfiguration(data: any, userId: number): AxiosPromise<any> {
    return axios().request({
      url: URLS().urlConference + '?userId=' + userId,
      method: 'put',
      data
    });
  },
};
